<script setup lang="ts">
import { Text } from '~ds/components/ui/typography';

interface Props {
  value: string | number;
  label: string;
  iconPath?: string;
  variant?: 'lime' | 'blue' | 'pink';
}

const props = withDefaults(defineProps<Props>(), {
  iconPath: undefined,
  variant: 'lime',
});

const containerVariants = cva('relative flex w-full flex-col items-center justify-center gap-2 rounded-2xl px-4 py-2', {
  variants: {
    variant: {
      lime: 'bg-secondary',
      blue: 'bg-brand-blue',
      pink: 'bg-brand-pink',
    },
  },
});

const containerClasses = computed(() => twMerge(containerVariants({ variant: props.variant })));
</script>

<template>
  <div :class="containerClasses">
    <NuxtImg
      v-if="iconPath"
      :src="iconPath"
      :alt="label"
      class="absolute left-3 top-3 aspect-square size-5"
    />
    <Text size="xl" weight="semibold">
      {{ value }}
    </Text>
    <Text size="sm" class="max-w-20 break-keep text-center">
      {{ label }}
    </Text>
  </div>
</template>
